import React from "react";
import { Words, FadeUp } from "@/components/Reveal";
import PillButton from "@/components/PillButton";

const NotFound = () => (
  <main className="flex min-h-screen items-center justify-center bg-white px-6 pt-20">
    <div className="flex flex-col items-center gap-6 text-center">
      <FadeUp mode="load" y={14}>
        <span className="eyebrow text-[12px] leading-[20px] text-charcoal-mid">404</span>
      </FadeUp>
      <h1 className="font-display text-[36px] leading-[1.1] text-black sm:text-[48px]" aria-label="Page not found">
        <Words text="This page hasn’t been seated yet." mode="load" delay={0.15} />
      </h1>
      <FadeUp mode="load" delay={0.4}>
        <p className="max-w-[420px] text-[15px] leading-[26px] text-charcoal">
          The page you’re looking for doesn’t exist — but the table is still open.
        </p>
      </FadeUp>
      <FadeUp mode="load" delay={0.55}>
        <PillButton href="/" dataTestId="notfound-home-button">
          Back Home
        </PillButton>
      </FadeUp>
    </div>
  </main>
);

export default NotFound;
